import { mergeDeepLeft } from 'ramda';

import {
  LOAD_CUSTOMER_TASKS
} from '../../actions/customer';

export default function dashboard(state = {}, action) {
    switch (action.type) {
        case LOAD_CUSTOMER_TASKS:
            return Object.assign({}, state, action.payload);
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/customer/index.js